import {ACTION_TYPES} from "../../../core/consts";
import {AnalyticsService} from "../../../third-party-services/analytics/analytics-service";
import {CompetitionsSliderEntityDisplayEvent} from "../models/competitions-slider-entity.display-event";
import {AnalyticsEventHandler} from "../../../infrastructure/handlers/analytics-event-handler";

export class CompetitionsSliderEntityDisplayEventHandler extends AnalyticsEventHandler {
  type = ACTION_TYPES.sliderEntityDisplay;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = CompetitionsSliderEntityDisplayEvent;
  }
}
